import React, { useState } from "react";
import {
  HosDriverProfileDto,
  useGetHosProfilesPaginatedWithSearchQuery,
} from "../../../api/vehiclesApi";
import HosTable from "./HosTable";
import { createSearchParams, hasActiveFilters } from "../../../utils/searchApiUtils";
import { useInfiniteDataTableItems } from "../../../hooks/useInfiniteDataTableItems";
import { DEFAULT_DATA_TABLE_PAGE_SIZE } from "../../../constants/dataTable";

const VehicleHosTab: React.FC = () => {
  const [page, setPage] = useState(0);
  const [searchFilters, setSearchFilters] = useState<Record<string, any>>({});

  const { data, isLoading, isFetching } = useGetHosProfilesPaginatedWithSearchQuery(
    createSearchParams(
      { pageNumber: page + 1, pageSize: DEFAULT_DATA_TABLE_PAGE_SIZE },
      hasActiveFilters(searchFilters) ? searchFilters : undefined
    )
  );
  const { accumulatedItems: profiles, resetAccumulatedItems } =
    useInfiniteDataTableItems<HosDriverProfileDto>(data?.items, page);

  const handleSearchChange = (filters: Record<string, any>) => {
    setSearchFilters(filters);
    resetAccumulatedItems();
    setPage(0);
  };

  const handleLoadMore = () => {
    if (data?.hasNextPage && !isFetching) {
      setPage((currentPage) => currentPage + 1);
    }
  };

  return (
    <HosTable
      profiles={profiles}
      isLoading={isLoading && profiles.length === 0}
      totalCount={data?.totalCount}
      hasNextPage={data?.hasNextPage}
      isLoadingMore={isFetching && profiles.length > 0}
      onLoadMore={handleLoadMore}
      
      // Search functionality
      enableSearch={true}
      onSearchChange={handleSearchChange}
    />
  );
};

export default VehicleHosTab;
